export default __webpack_public_path__ + "static/media/perfectum.75467891.jpg";